export class CategoryDetails {
    name: string;
	description: string;
	imageUrl: string;
    trending: boolean;
    keywords: string;
}


// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/categories/details/category-details.model.ts